// components/Header.tsx
import { ArrowUpRight, Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLocation, useNavigate } from "react-router-dom";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 800, once: false });
  }, []);

  const { pathname } = useLocation();

  const navigate = useNavigate();

  return (
    <section className="fixed top-0 w-full z-50 bg-white box-border blairITCMedium">
      <header className="border-b">
        <div className="mx-auto flex items-center justify-between px-6 lg:px-24 py-4 max-w-[90%] lg:max-w-[90%]">
          {/* Left: Navigation */}
          <nav className="hidden lg:flex items-center gap-8 font-medium text-[13px]">
            <p
              className="relative cursor-pointer group"
              onClick={() => {
                if (pathname !== "/") {
                  navigate("/", { state: { scrollTo: "about" } });
                } else {
                  document
                    .getElementById("about")
                    ?.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              ABOUT
              <span
                className="
      absolute left-[20%] -bottom-2 h-[3px] w-0 bg-[#95822C]
      transition-all duration-300 ease-out
      group-hover:w-[80%]
    "
              ></span>
            </p>

            <p
              className="relative cursor-pointer group"
              onClick={() => {
                if (pathname !== "/") {
                  navigate("/", { state: { scrollTo: "highlights" } });
                } else {
                  document
                    .getElementById("highlights")
                    ?.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              HIGHLIGHTS
              <span
                className="
      absolute left-[20%] -bottom-2 h-[3px] w-0 bg-[#95822C]
      transition-all duration-300 ease-out
      group-hover:w-[80%]
    "
              ></span>
            </p>
            <p
              className="relative cursor-pointer group"
              onClick={() => {
                if (pathname !== "/") {
                  navigate("/", { state: { scrollTo: "venue" } });
                } else {
                  document
                    .getElementById("venue")
                    ?.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              VENUE
              <span
                className="
      absolute left-[20%] -bottom-2 h-[3px] w-0 bg-[#95822C]
      transition-all duration-300 ease-out
      group-hover:w-[80%]
    "
              ></span>
            </p>
          </nav>

          {/* Center: Logo */}
          <div className="absolute left-1/2 transform -translate-x-1/2">
            <p
              onClick={() => {
                if (pathname !== "/") {
                  navigate("/", { state: { scrollTo: "home" } });
                } else {
                  document
                    .getElementById("home")
                    ?.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              <svg
                className="h-auto w-[160px] lg:w-[200px]"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1125 191.23"
              >
                <path d="M148.41,109.33h-17V25.26h-.43l-53.39,67-53-67h-.43v84.07h-17V6.52h21.3L77.69,68.65,127.18,6.52h21.23Zm148.39,0H278.16l-11.85-23H197.07l-11.85,23H166.58L221,6.52h21.44ZM258,71,231.85,21.18,205.34,71Zm173.51,38.34H411.73L383.91,70.14H332v39.19H315V6.52h81.09q16.19,0,25.41,8.73T430.7,38.9q0,13.07-7.52,21-7,7.4-19.17,9.38ZM393.5,54.8q19.74,0,19.74-15.9,0-17-21.3-17H332V54.8Zm141,55.24a85.67,85.67,0,0,1-18.75,2.13q-27,0-45.3-13.77Q449.6,82.64,449.59,57.64q0-24.7,21-40.61Q489.06,3.11,515.76,3.11t45,13.91q20.87,15.75,20.87,40.57,0,31.64-31.28,47.1l12.81,14.11-16,5.15ZM539,92.19Q563.91,82.1,563.9,57.52q0-18-15.48-29.41-13.2-9.66-32.66-9.66t-32.94,9.67q-15.48,11.25-15.48,29.45,0,17.35,13.27,28.17t35.12,10.81c1,0,3.08-.09,6.11-.26L510.79,83.91l16.3-4.86ZM724.22,76.1q0,16.05-15.62,26-15.92,10.36-42.46,10.36T623.4,102.09Q607.77,92,607.78,76.1V6.52h17V72q0,12.08,10.58,18.46t30.74,6.39q20.16,0,30.6-6.39T707.18,72V6.52h17V76.1Zm141.29,33.23H757.87V6.52H861.53V21.86H774.91V48.27h60.21V63.61H774.91V94H865.5v15.34Zm111-78.67Q953.69,19,930,19q-15.76,0-24.14,3.69t-8.38,10.22q0,6.82,8.95,9.94,6.39,2.28,20.87,3.13,21.3,1.41,28.12,2.27,19.3,2.55,28.54,9.51t9.23,19.74q0,16.33-14.48,25.28t-41.61,8.94q-39.33,0-61.2-17.32l9.37-12.35a97.89,97.89,0,0,0,52,14.76q18,0,28-5,9.51-4.81,9.51-13.2,0-9.8-12.49-13.07Q955.67,63.89,927,62q-25.43-1.7-35.64-6.81-11.93-6-11.93-20,0-14.48,13.56-22.86T931.25,4q33.22,0,55.66,15.2Zm129.79,0Q1083.46,19,1059.76,19q-15.77,0-24.14,3.69t-8.38,10.22q0,6.82,9,9.94,6.39,2.28,20.87,3.13,21.3,1.41,28.12,2.27,19.3,2.55,28.54,9.51T1123,77.52q0,16.33-14.48,25.28t-41.61,8.94q-39.33,0-61.2-17.32L1015,82.07a97.87,97.87,0,0,0,52,14.76q18,0,28-5,9.51-4.81,9.51-13.2,0-9.8-12.49-13.07-6.54-1.7-35.22-3.55-25.42-1.7-35.64-6.81-11.92-6-11.93-20,0-14.48,13.56-22.86T1061,4q33.23,0,55.66,15.2l-10.36,11.5ZM456.62,175.33H423.35V139.85h5.88V170h27.39v5.29Zm47.73-17.79a16.86,16.86,0,0,1-7.15,14.11q-6.29,4.71-15.59,4.71t-15.68-4.76a16.8,16.8,0,0,1-7.15-14.06q0-8.52,7.25-14a25.15,25.15,0,0,1,15.58-4.8q9.27,0,15.54,4.8,7.2,5.49,7.2,14Zm-6.12,0a12,12,0,0,0-5.3-10.09,18.65,18.65,0,0,0-11.32-3.33q-7.39,0-12.05,3.79a12.48,12.48,0,0,0-.1,19.36Q474,171,481.61,171t12.08-3.73a12,12,0,0,0,4.54-9.7Zm56.39,17.79h-7.31l-27.08-29.09v29.09h-5.88V139.85h7.3L548.74,169V139.85h5.89v35.48Zm34.3-35.48q9.27,0,14.68,4.93T609,158a16.16,16.16,0,0,1-5.73,12.65,19.32,19.32,0,0,1-13.23,4.7H566.48V139.85ZM590.54,170a11.75,11.75,0,0,0,8.7-3.42,11.92,11.92,0,0,0,3.4-8.78,12.12,12.12,0,0,0-3.65-9.2,13.26,13.26,0,0,0-9.58-3.5h-17V170Zm71.83-12.5a16.83,16.83,0,0,1-7.15,14.11q-6.27,4.71-15.58,4.71T624,171.6a16.81,16.81,0,0,1-7.16-14.06q0-8.52,7.26-14a25.13,25.13,0,0,1,15.58-4.8q9.25,0,15.53,4.8,7.2,5.49,7.2,14Zm-6.12,0A11.94,11.94,0,0,0,651,147.45a18.67,18.67,0,0,0-11.32-3.33q-7.39,0-12.06,3.79a12.48,12.48,0,0,0-.09,19.36q4.56,3.71,12.15,3.7t12.08-3.73a12,12,0,0,0,4.53-9.7Zm56.4,17.79h-7.32l-27.08-29.09v29.09h-5.88V139.85h7.3L706.77,169V139.85h5.88v35.48Z" />
              </svg>
            </p>
          </div>

          {/* Right: CTA */}
          <button
            onClick={() => {
              if (pathname !== "/") {
                navigate("/", { state: { scrollTo: "tickets" } });
              } else {
                document
                  .getElementById("tickets")
                  ?.scrollIntoView({ behavior: "smooth" });
              }
            }}
            className="hidden md:inline-flex items-center gap-2 bg-[#4E5C36] px-5 py-2 text-white text-xs font-medium hover:bg-[#3b4726] transition"
          >
            Reserve Seat
            <span className="inline-flex items-center justify-center bg-white text-[#4E5C36] p-1">
              <ArrowUpRight size={14} />
            </span>
          </button>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-[#4E5C36] focus:outline-none"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <>
            {/* Blurred Overlay */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
              onClick={() => setIsOpen(false)}
            />

            {/* Sidebar */}
            <motion.div
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ duration: 0.4 }}
              className="fixed top-0 right-0 h-full w-4/5 max-w-sm z-50 bg-gradient-to-r from-[#fff9f8] to-[#f5f5f5] shadow-xl border-l border-gray-100 flex flex-col"
              data-aos="fade-left"
            >
              {/* Centered Logo */}
              <div className="flex justify-center items-center py-6 border-b">
                <p
                  onClick={() => {
                    if (pathname !== "/") {
                      setIsOpen(false);
                      navigate("/", { state: { scrollTo: "home" } });
                    } else {
                      setIsOpen(false);
                      document
                        .getElementById("home")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                >
                  <svg
                    className="h-auto w-[140px]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1125 191.23"
                  >
                    <path d="M148.41,109.33h-17V25.26h-.43l-53.39,67-53-67h-.43v84.07h-17V6.52h21.3L77.69,68.65,127.18,6.52h21.23Zm148.39,0H278.16l-11.85-23H197.07l-11.85,23H166.58L221,6.52h21.44ZM258,71,231.85,21.18,205.34,71Zm173.51,38.34H411.73L383.91,70.14H332v39.19H315V6.52h81.09q16.19,0,25.41,8.73T430.7,38.9q0,13.07-7.52,21-7,7.4-19.17,9.38ZM393.5,54.8q19.74,0,19.74-15.9,0-17-21.3-17H332V54.8Zm141,55.24a85.67,85.67,0,0,1-18.75,2.13q-27,0-45.3-13.77Q449.6,82.64,449.59,57.64q0-24.7,21-40.61Q489.06,3.11,515.76,3.11t45,13.91q20.87,15.75,20.87,40.57,0,31.64-31.28,47.1l12.81,14.11-16,5.15ZM539,92.19Q563.91,82.1,563.9,57.52q0-18-15.48-29.41-13.2-9.66-32.66-9.66t-32.94,9.67q-15.48,11.25-15.48,29.45,0,17.35,13.27,28.17t35.12,10.81c1,0,3.08-.09,6.11-.26L510.79,83.91l16.3-4.86ZM724.22,76.1q0,16.05-15.62,26-15.92,10.36-42.46,10.36T623.4,102.09Q607.77,92,607.78,76.1V6.52h17V72q0,12.08,10.58,18.46t30.74,6.39q20.16,0,30.6-6.39T707.18,72V6.52h17V76.1Zm141.29,33.23H757.87V6.52H861.53V21.86H774.91V48.27h60.21V63.61H774.91V94H865.5v15.34Zm111-78.67Q953.69,19,930,19q-15.76,0-24.14,3.69t-8.38,10.22q0,6.82,8.95,9.94,6.39,2.28,20.87,3.13,21.3,1.41,28.12,2.27,19.3,2.55,28.54,9.51t9.23,19.74q0,16.33-14.48,25.28t-41.61,8.94q-39.33,0-61.2-17.32l9.37-12.35a97.89,97.89,0,0,0,52,14.76q18,0,28-5,9.51-4.81,9.51-13.2,0-9.8-12.49-13.07Q955.67,63.89,927,62q-25.43-1.7-35.64-6.81-11.93-6-11.93-20,0-14.48,13.56-22.86T931.25,4q33.22,0,55.66,15.2Zm129.79,0Q1083.46,19,1059.76,19q-15.77,0-24.14,3.69t-8.38,10.22q0,6.82,9,9.94,6.39,2.28,20.87,3.13,21.3,1.41,28.12,2.27,19.3,2.55,28.54,9.51T1123,77.52q0,16.33-14.48,25.28t-41.61,8.94q-39.33,0-61.2-17.32L1015,82.07a97.87,97.87,0,0,0,52,14.76q18,0,28-5,9.51-4.81,9.51-13.2,0-9.8-12.49-13.07-6.54-1.7-35.22-3.55-25.42-1.7-35.64-6.81-11.92-6-11.93-20,0-14.48,13.56-22.86T1061,4q33.23,0,55.66,15.2l-10.36,11.5ZM456.62,175.33H423.35V139.85h5.88V170h27.39v5.29Zm47.73-17.79a16.86,16.86,0,0,1-7.15,14.11q-6.29,4.71-15.59,4.71t-15.68-4.76a16.8,16.8,0,0,1-7.15-14.06q0-8.52,7.25-14a25.15,25.15,0,0,1,15.58-4.8q9.27,0,15.54,4.8,7.2,5.49,7.2,14Zm-6.12,0a12,12,0,0,0-5.3-10.09,18.65,18.65,0,0,0-11.32-3.33q-7.39,0-12.05,3.79a12.48,12.48,0,0,0-.1,19.36Q474,171,481.61,171t12.08-3.73a12,12,0,0,0,4.54-9.7Zm56.39,17.79h-7.31l-27.08-29.09v29.09h-5.88V139.85h7.3L548.74,169V139.85h5.89v35.48Zm34.3-35.48q9.27,0,14.68,4.93T609,158a16.16,16.16,0,0,1-5.73,12.65,19.32,19.32,0,0,1-13.23,4.7H566.48V139.85ZM590.54,170a11.75,11.75,0,0,0,8.7-3.42,11.92,11.92,0,0,0,3.4-8.78,12.12,12.12,0,0,0-3.65-9.2,13.26,13.26,0,0,0-9.58-3.5h-17V170Zm71.83-12.5a16.83,16.83,0,0,1-7.15,14.11q-6.27,4.71-15.58,4.71T624,171.6a16.81,16.81,0,0,1-7.16-14.06q0-8.52,7.26-14a25.13,25.13,0,0,1,15.58-4.8q9.25,0,15.53,4.8,7.2,5.49,7.2,14Zm-6.12,0A11.94,11.94,0,0,0,651,147.45a18.67,18.67,0,0,0-11.32-3.33q-7.39,0-12.06,3.79a12.48,12.48,0,0,0-.09,19.36q4.56,3.71,12.15,3.7t12.08-3.73a12,12,0,0,0,4.53-9.7Zm56.4,17.79h-7.32l-27.08-29.09v29.09h-5.88V139.85h7.3L706.77,169V139.85h5.88v35.48Z" />
                  </svg>
                </p>
              </div>

              {/* Menu Items */}
              <div className="flex flex-col items-center space-y-6 py-8 text-center">
                <p
                  onClick={() => {
                    if (pathname !== "/") {
                      setIsOpen(false);
                      navigate("/", { state: { scrollTo: "about" } });
                    } else {
                      setIsOpen(false);
                      document
                        .getElementById("about")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                  className="text-gray-800 font-medium hover:text-[#e28580] transition cursor-pointer"
                >
                  ABOUT
                </p>
                <p
                  onClick={() => {
                    if (pathname !== "/") {
                      setIsOpen(false);
                      navigate("/", { state: { scrollTo: "highlights" } });
                    } else {
                      setIsOpen(false);
                      document
                        .getElementById("highlights")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                  className="text-gray-800 font-medium hover:text-[#e28580] transition cursor-pointer uppercase"
                >
                  highlights
                </p>
                <p
                  onClick={() => {
                    if (pathname !== "/") {
                      setIsOpen(false);
                      navigate("/", { state: { scrollTo: "venue" } });
                    } else {
                      setIsOpen(false);
                      document
                        .getElementById("venue")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                  className="text-gray-800 font-medium hover:text-[#e28580] transition cursor-pointer uppercase"
                >
                  venue
                </p>
                <p
                  onClick={() => {
                    setIsOpen(false);
                    navigate("/faq");
                  }}
                  className="text-gray-800 font-medium hover:text-[#e28580] transition cursor-pointer uppercase"
                >
                  FAQ
                </p>

                <button
                  onClick={() => {
                    if (pathname !== "/") {
                      setIsOpen(false);
                      navigate("/", { state: { scrollTo: "tickets" } });
                    } else {
                      setIsOpen(false);
                      document
                        .getElementById("tickets")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                  className="inline-flex items-center gap-2 bg-[#4E5C36] px-5 py-2 text-white text-sm font-medium hover:bg-[#3b4726] transition"
                >
                  Reserve Seat
                  <span className="inline-flex items-center justify-center bg-white text-[#4E5C36] p-1">
                    <ArrowUpRight size={14} />
                  </span>
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </section>
  );
}
